module.exports = __webpack_public_path__ + "static/img/not.a4ed1409.jpeg";